import { sendEvent, SendEventParams } from '@/utils/sendEvent';
import { GomarkePixelConfig, PixelResponse } from '../../types';

/**
 * Classe base para todos os trackers
 * Fornece funcionalidades comuns como envio de eventos e validação
 */
export abstract class BaseTracker {
  protected config: GomarkePixelConfig;
  protected sessionId: string;
  protected visitorId: string;
  protected version: string;

  constructor(
    config: GomarkePixelConfig,
    sessionId: string,
    visitorId: string,
    version: string
  ) {
    this.config = config;
    this.sessionId = sessionId;
    this.visitorId = visitorId;
    this.version = version;
  }

  /**
   * Envia evento para a API usando sendBeacon (com fallback para fetch)
   */
  protected async sendEvent({
    category,
    type,
    eventData,
    config,
    sessionId,
    visitorId,
    version,
    scriptUrl,
  }: SendEventParams): Promise<PixelResponse> {
    return sendEvent({
      visitorId,
      category,
      type,
      eventData,
      config,
      sessionId,
      version,
      scriptUrl,
    });
  }

  /**
   * Valida se os parâmetros obrigatórios estão presentes
   */
  protected validateRequiredParams(
    params: Record<string, unknown>,
    requiredFields: string[]
  ): void {
    const missingFields = requiredFields.filter(
      field => params[field] === undefined || params[field] === null
    );

    if (missingFields.length > 0) {
      throw new Error(
        `Campos obrigatórios ausentes: ${missingFields.join(', ')}`
      );
    }
  }

  /**
   * Retorna o payload (SendEventParams) para envio centralizado no ConversionEngine.
   * Cada tracker implementa com a mesma estrutura que envia em track().
   */
  public abstract getPayload(...args: unknown[]): SendEventParams;

  /**
   * Método abstrato que deve ser implementado por cada tracker específico.
   * Por padrão pode ser validate + sendEvent(getPayload(...)); o engine usa getPayload + sendEvent.
   */
  public abstract track(...args: unknown[]): Promise<PixelResponse>;
}
